import React, { FC } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useStyles } from './Picture.styles';
import { getImgSrcSet } from 'shared/utils/get-img-src-set';

export interface ResponsiveImageSrc {
  breakpoint?: number;
  width?: string;
  height?: string;
  alt?: string;
  densities?: number[];
  getSrc: (density?: number) => string;
}

interface PictureProps {
  defaultSrc: ResponsiveImageSrc;
  sources: ResponsiveImageSrc[];
}

export const Picture: FC<PictureProps> = ({ defaultSrc, sources }) => {
  const { classes } = useStyles();

  if (!defaultSrc?.getSrc) {
    return null;
  }

  const renderSources = () => {
    if (!Array.isArray(sources) || !sources.length) return null;

    return sources.reverse().map((source) => {
      const sourceProps: Record<string, string> = {
        srcSet: source.densities?.length
          ? getImgSrcSet(source.densities, source.getSrc)
          : source.getSrc(),
      };

      if (source.breakpoint) {
        sourceProps.media = `(min-width: ${source.breakpoint}px)`;
      }

      return <source {...sourceProps} key={sourceProps.srcSet} />;
    });
  };

  return (
    <picture className={classes.picture}>
      {renderSources()}
      <LazyLoadImage className={classes.img} src={defaultSrc.getSrc()} alt={defaultSrc.alt} />
    </picture>
  );
};
